"use strict";
import angular from "angular";
import fbPageIdHtmlUrl from "./views/facebookPageId.html";
var app = angular.module("app.facebookPageId.component", []);
app.component("facebookPageId", {
    bindings: {
        selectedFacebookPageid: "=",
        clientId: "=",
        clusterId: "=",
        showActions: "<",
        model: "=",
        isFormEdit: '=',
    },
    templateUrl: fbPageIdHtmlUrl,
    controller: function ($scope,FormService) {
        var self = this;
        self.selectedValue ='';
        self.facebookAccounts = [];

        self.fetchFacebookAccounts = function () {
            FormService.fetchFacebookAccounts(self.clusterId,self.clientId).then(function () {
                if (FormService.facebookAccounts) {
                    self.facebookAccounts = FormService.facebookAccounts;
                }
            }, function () {
                console.log("Error while fetching facebook accounts !");
            });
        }

        self.saveAccount = function (){
           var jsonObject = {
                '__facebook_pageId': self.selectedValue
            };
            self.model.__facebook_pageId= JSON.stringify(jsonObject);
            console.log(self.selectedFacebookPageid);
            return self.selectedValue;
        }

        self.initComponent = function () {
            if(self.selectedFacebookPageid && !_.isEmpty(self.selectedFacebookPageid)) {
                self.selectedValue = self.selectedFacebookPageid;
            }

            if (self.selectedValue && !_.isEmpty(self.selectedValue)) {
                var jsonValue = JSON.parse(self.selectedValue);
                self.selectedValue=jsonValue['__facebook_pageId']['page_name'];
                self.showActions = self.isFormEdit || false;
                self.editMode = !!self.isFormEdit;
                self.enableViewMode = !self.isFormEdit;
                self.fetchFacebookAccounts();
            } else {
                self.selectedValue='';
                self.showActions = false;
                self.enableViewMode = false;
                self.fetchFacebookAccounts();
            }
        };
        self.initComponent();
    },
});